<template>
  <v-container
    class="project-details ma-5 pa-0"
    fluid
  >
    <v-row justify="center" align="center">
      <v-col cols="6" class="pa-0">
        <v-img :src="portraitSrc" 
          :lazy-src="portraitLoading"
          width="100%"
          class="grey darken-4"
        >
          <template v-slot:placeholder>
            <v-row
              class="fill-height ma-0"
              align="center"
              justify="center"
            >
              <v-progress-circular
                indeterminate
                color="grey lighten-5"
              ></v-progress-circular>
            </v-row>
          </template>
          <v-container class="py-0 my-0" style="background-color:black; color:white; opacity:0.5">
            <v-row class="pt-0 ma-0" align="center" justify="start" style="font-size:32px">
              {{project.name}}
            </v-row>
            <v-row align="center" class="pa-0 ma-0" justify="start" style="font-size:16px">
              <v-col cols="6" class="pa-0 ma-0">
                Fecha de creación: {{returnDate(project.creationDate)}}
              </v-col>
              <v-col cols="6" class="text-end pa-0 ma-0">
                {{project.developer}}
              </v-col>
            </v-row>
          </v-container>
        </v-img>
      </v-col>
      <v-col cols="3" class="ma-5 pa-0" >
        <funding-card :projectInfo="project" :key="fcKey"/>
      </v-col>
      <v-col cols="3" />
    </v-row>
    <v-row>
      <v-col cols="12" class="pa-0 ma-0">
        <v-card class="pt-0 pl-2 pb-2 pa-2" width="100%" outlined >
          <v-card-title> {{project.name}}</v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <vue-simple-markdown 
                  style="line-height:20pt;"
                  :source="project.description"
                />              
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-for="(item,index) in project.projectCards" :key="index" >
      <card-view v-if="item.cardType!==0" :title="item.name" class="ma-0 pa-0">
        <component :is="cardOptions[item.cardType]" :preRegisteredValues="returnCardValues(project.projectCards[index])" :idCard="index.toString()"/>
      </card-view>
    </v-row>
    <v-row align="center" justify="center">
      <v-btn
        color="success"
        class="mr-5"
        v-if="(userRole==='admin' || (userRole==='developer' && user === project.developer) )&& project.status==='Approved' "
        @click.native.once="publishProject"
      >
        Publicar
      </v-btn>
      <v-btn
        color="success"
        class="mr-5"
        v-if="userRole==='admin' && project.status ==='Revision'"          
        @click.native.once="approveProject"
      >
        Aprobar
      </v-btn>
      <v-btn
        color="success"
        class="mr-5"
        v-if="readyForRevision"          
        @click.native.once="setProjectForRevision"
        :disabled="!project.fundingCampaignDTO.creditsAmount >0"
      >
        Postular 
      </v-btn>
      <span v-if="readyForRevision && !project.fundingCampaignDTO.creditsAmount >0" class="font-weight-thin" style="color:red;"> Falta campaña de fondeo. </span>
      <v-btn
        color="success"
        v-if="project.status === 'Published' && project.developer === user && project.dividendsReady"
        @click.native.once="dividends=true"
        :key="'d'+dividendKey"
      >
        Pagar dividendos
      </v-btn>
    </v-row>
    <investment-modal v-if="modal" :dialog="modal" :actionResult="getProjectInformation"/>  
    <dividends-dialog v-if="dividends" :dialog="dividends" @cancel="cancelDividendsModal()" />
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex'
export default {
  components:{
    CardView:()=>import('@/components/cards/CardView.vue'),
    ImagesCardView:()=>import('@/components/cards/ImagesCardView.vue'),
    TextCardView:()=>import('@/components/cards/TextCardView.vue'),
    VideoCardView:()=>import('@/components/cards/VideoCardView.vue'),
    MapCardView:()=>import('@/components/cards/MapCardView.vue'),/**/
    FundingCard:()=>import('@/components/cards/FundingCard.vue'),
    InvestmentModal:()=>import('../fundingModules/InvestmentModal.vue'),
    DividendsDialog:()=>import('@/views/projectsModule/DividendsDialog.vue')
  },
  data(){
    return {
      project:{
        fundingCampaignDTO: {
          creditsAmount: 0,
          creditsFunded:0,
        }
      },
      dividends:false,
      portraitId:undefined,
      cardOptions:["","ImagesCardView","VideoCardView","TextCardView","MapCardView"],
      fcKey:0,
      dividendKey:0,
      modal: false
    }
  },
  beforeMount(){
    this.getProjectInformation();
  },
  computed: {
    ...mapGetters([
      'oidcIsAuthenticated',
      'oidcUser'
    ]),
    portraitSrc:{
      get(){
        if(this.portraitId!==undefined)
          return process.env.VUE_APP_CF_API_URL + '/api/projects/images/' + this.portraitId
        else
          return ''
      }
    },
    portraitLoading:{
      get(){
        return process.env.VUE_APP_BASE_URL + '/static/loading.jpg'
      }
    },
    estimatedReturn:{
      get(){
        return (this.project.estimatedReturn * 100).toFixed(2) + " %"
      }
    },
    userRole(){
      return this.$store.getters.getUserRole
    },
    triggerModal(){
      return this.$store.getters.getInvestmentModalTrigger
    },
    user(){
      if(this.oidcIsAuthenticated){
        return this.oidcUser.name
      } else {
        return "none"
      }
    },
    readyForRevision(){
      return (this.user===this.project.developer && this.project.status==='Draft' )
    },
    fundingCampaigns(){
      console.log('fcs',this.$store.getters.getFundingCampaigns)
      return this.project.fundingCampaignDTO.creditsAmount >0 || this.$store.getters.getFundingCampaigns.filter(fc=> fc.creditsAmount >0).length > 0
    }

  },
  methods:{
    returnDate(){
      var date= new Date(this.project.creationDate)
      date.setDate(date.getDate() + (this.project.profitsBeginQuantity * this.project.profitsBeginTimePeriod))
      return date.toLocaleDateString('es-AR')
    },
    returnCardValues(card){
      switch(card.cardType){
        case 1:
          return card.imageSlide
        case 2:
          return card.link.split('?v=')[1]
        case 3:
          return card.text
        case 4:
          return card.geoLocation[0]
        default:
      
          break;
      }
    },
    getProjectInformation(){
      this.$cf_api.getProject(this.$route.params.id).then(response=>{
        console.log('resp', response.data)
        this.project = response.data
        if(this.project.fundingCampaignDTO===null){
          this.project.fundingCampaignDTO = {
            creditsAmount: 0,
            creditsFunded:0,
          }
        }
        this.portraitId = response.data.portraitId
      }).catch(()=>{
        this.$router.push('/')
      })
    },
    publishProject(){
      this.$cf_api.publishProject(this.$route.params.id).then(()=> {
        this.$store.dispatch('setSnack','El proyecto ha sido publicado.')
        this.$router.go()
      })
    },
    approveProject(){
      this.$cf_api.approveProject(this.$route.params.id).then(()=> {
        this.$store.dispatch('setSnack','El proyecto ha sido aprobado.')
        this.$router.go()
      })
    },
    setProjectForRevision(){
      this.$cf_api.setProjectForRevision(this.$route.params.id).then(()=> {
        this.$store.dispatch('setSnack','El proyecto ha sido postulado.')
        this.$router.go()
      })
    },
    refreshFundingCampaigns(){
      this.$cf_api.getFundingCampaignsFor(this.project.projectId).then(r=>{
        this.project.fundingCampaignDTO=r.data
        this.fcKey++
      }).catch(e=>{
        console.log('Error refreshing funding campaigns: ',e)
      })
    },
    cancelDividendsModal(){
      this.dividends=false
      this.dividendKey++
    }
  },
  watch:{
    triggerModal(newVal){
      this.modal=newVal
      if(!newVal){
        this.refreshFundingCampaigns()
      }
    }
  }
}
</script>
<style scoped>
.project-details{font-family:Inter,Arial,sans-serif;color:#173347}.project-details :deep(.v-card){border-color:#e6e1d9!important;border-radius:0!important;box-shadow:none!important}.project-details :deep(.v-card__title){font-family:Georgia,serif;font-size:29px;font-weight:400;color:#173347}.project-details :deep(.v-card__text){font-size:14px;line-height:1.7;color:#61747e}.project-details :deep(.v-btn){border-radius:0!important;text-transform:none!important;letter-spacing:0!important;font-weight:700!important}.field-header{font-size:18px;font-weight:bold}
</style>
